
import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navigation() {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { path: '/', label: 'INTERFACE' },
    { path: '/operations', label: 'OPERATIONS' },
    { path: '/proof', label: 'PROOF' },
    { path: '/payment', label: 'PAY NOW' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'shadow-lg' : ''
      } bg-black`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between h-20">
        {/* Logo - Exact LONE Logo */}
        <Link to="/" className="flex items-center cursor-pointer">
          <img 
            src="https://static.readdy.ai/image/d40f812adce9746c671cc6e9152e021e/0ce60cc9cd67bd7abb608b30f1f31592.jpeg"
            alt="LONE Logo"
            className="h-14 w-auto"
          />
        </Link>

        {/* Desktop Navigation */}
        <div className="flex items-center space-x-12">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`font-orbitron text-sm font-medium tracking-wider transition-all duration-300 whitespace-nowrap cursor-pointer ${
                link.path === '/payment'
                  ? location.pathname === '/payment'
                    ? 'text-electric-cyan'
                    : 'text-electric-cyan/70 hover:text-electric-cyan'
                  : location.pathname === link.path
                  ? 'text-white'
                  : 'text-gray-400 hover:text-white'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <a
          href="tel:+14158885336"
          className="px-6 py-2.5 bg-white text-black font-orbitron font-semibold text-sm rounded-md hover:bg-gray-200 transition-all duration-300 whitespace-nowrap cursor-pointer"
        >
          CONTACT US
        </a>
      </div>
    </nav>
  );
}
